export default __webpack_public_path__ + "locales/cs/VersionHistory.json?hash=21d5dc456a3bfb01f97b621800503f27";